import VasQrInfo from "./vas-qr.page";

export default VasQrInfo;
